import store from '@/store';
export function getMenuIndex(index1, index2) {
  if (index2 === undefined) {
    return `${index1 + 1}`;
  }
  return `${index1 + 1}-${index2 + 1}`;
}

export function getActiveMenu(menus, route) {
  const { meta, path } = route;
  let activeMenu = '';
  activeMenu = '1';
  if (menus && path) {
    menus.some((menu, index) => {
      if (menu.childrenNode && menu.childrenNode.length) {
        menu.childrenNode.some((submenu, index1) => {
          if (meta.activeMenu) {
            if (meta.activeMenu === submenu.menuUrl) {
              activeMenu = `${index + 1}-${index1 + 1}`;
              return true;
            }
          } else if (`${path}/`.indexOf(`${submenu.menuUrl}/`) > -1) {
            activeMenu = `${index + 1}-${index1 + 1}`;
            return true;
          }
          return false;
        });
      } else if (`${path}/`.indexOf(`${menu.menuUrl}/`) > -1) {
        activeMenu = `${index + 1}`;
        return true;
      }
      return false;
    });
  }
  return activeMenu;
}

export function getCurrentMenu(menus, route) {
  let _menus = menus;
  const { meta, params } = route;

  // 聚合商户逻辑
  // 收单、付款公用页面的子级resourceCode都是一样的，只能通过最外层的resourceCode来区分，否则页面的权限会拿错
  if (store.getters.app.userLogin.isAggregateMerchant) {
    if (params.type) {
      if (params.type.includes('acq')) {
        _menus = menus?.filter((item) => item.resourceCode === 'bigAcquiring');
      }
      if (params.type.includes('payout')) {
        _menus = menus?.filter((item) => item.resourceCode === 'bigPayout');
      }
    }
  }

  let menu = null;
  const getMenus = (menuList) => {
    for (let i = 0; i < menuList.length; i++) {
      if (meta.resourceCode && menuList[i].resourceCode === meta.resourceCode) {
        menu = menuList[i];
        return;
      }
      if (menuList[i].childrenNode && menuList[i].childrenNode.length) {
        getMenus(menuList[i].childrenNode);
      }
    }
  };
  getMenus(_menus);

  return menu;
}
